export default __webpack_public_path__ + "static/media/yo_0.0663fc30.mp3";